<ng-container *ngIf="toolbar">
  <div class="quill-editor"></div>
</ng-container>
<ng-container *ngIf="!toolbar">
  <div class="oa-textarea scrollable" contenteditable="true" [innerHTML]="content" (blur)="onChange($event)">
  </div>
</ng-container>